<template>
  <div>
    <v-app-bar app elevation="0" color="white">
      <!-- <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon> -->
      <div class="d-flex flex-row align-center">
        <v-img
          alt="Cellsmart Logo"
          class="shrink"
          contain
          src="@/assets/fullLogo.png"
          width="160"
          @click="clickAction"
        />
      </div>

      <v-spacer></v-spacer>
      <Menu />
    </v-app-bar>
    <!-- <v-navigation-drawer v-model="drawer" absolute temporary>
      <v-list nav dense>
        <v-list-item-group active-class="deep-purple--text text--accent-4">
          <v-list-item>
            <v-list-item-title>Foo</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title>Bar</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title>Fizz</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title>Buzz</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer> -->
  </div>
</template>

<script>
// import employeeService from "@/modules/Employee/service";
import Menu from "@/components/AppBarMenu.vue";

export default {
  name: "app-bar",
  data() {
    return {
      drawer: false,
    };
  },
  components: {
    Menu,
  },

  methods: {
    clickAction() {
      this.$router.go(0);
    },
  },
};
</script>

<style>
</style>